var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#D4AD53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2457 6.3475C17.5699 6.12636 16.8327 6 16.0802 6C13.9147 6 11.9642 7.0109 10.6587 8.60623L14.0068 11.4968L18.2457 6.3475Z",
    fill: "#1A73E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6587 8.60645C9.62969 9.87007 9 11.5128 9 13.2819C9 14.6561 9.26109 15.7617 9.70648 16.7569L14.0068 11.497L10.6587 8.60645Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0956 10.5018C17.6007 10.5018 18.814 11.7497 18.814 13.2976C18.814 13.9768 18.5682 14.6086 18.1689 15.0983C18.1689 15.0983 20.3037 12.4763 22.3924 9.9332C21.5324 8.2273 20.0426 6.93208 18.2457 6.34766L14.0068 11.4969C14.5137 10.8967 15.2509 10.5018 16.0956 10.5018Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0956 16.0772C14.5905 16.0772 13.3772 14.8294 13.3772 13.2815C13.3772 12.6023 13.6076 11.9704 14.0069 11.4966L9.70657 16.7564C10.4438 18.4307 11.6724 19.7891 12.9318 21.4792L18.169 15.0821C17.6621 15.6981 16.9249 16.0772 16.0956 16.0772Z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0766 23.2486C20.4418 19.4419 23.1909 17.7202 23.1909 13.2975C23.1909 12.0813 22.8991 10.944 22.3923 9.93311L12.9316 21.4795C13.331 22.0166 13.7456 22.6326 14.1449 23.2644C15.5886 25.5547 15.1893 26.9131 16.1108 26.9131C17.0323 26.9131 16.633 25.5389 18.0766 23.2486Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMap);
export default __webpack_public_path__ + "static/media/google_map.901040b3d6d5f80dc51e3b1e5c2755fb.svg";
export { ForwardRef as ReactComponent };